// @flow
import { FormBuilderContext } from 'pages/Contexts/FormBuilderContext'
import * as React from 'react'
import styled, { css } from 'styled-components'
import theme from 'ui/theme'

import BuilderPopupQuestion from './BuilderPopupQuestion'

type Props = {
  id: string,
  dataCy?: string,
  type: string,
  hasMakeSmallerOption?: boolean,
  hasMakeBiggerOption?: boolean,
  hasErrors?: boolean,
  children: React.Node,
  hideMenu?: boolean,
  hasMoveUp?: boolean,
  hasMoveDown?: boolean,
  noBorder?: boolean,
  dottedBorder?: boolean,
  titleVariant?: boolean,
}

type StyledSelectableItemProps = {
  hasErrors?: boolean,
  isSelected?: boolean,
  noBorder?: boolean,
  dottedBorder?: boolean,
  titleVariant?: boolean,
}

// TODO: replace this with SelectableFlatCard when the time comes
const StyledSelectableItem = styled.div`
  border-width: 4px;
  overflow: hidden;
  border-width: ${theme.width.border};
  border-style: ${({ dottedBorder }: StyledSelectableItemProps) =>
    dottedBorder ? 'dotted' : 'solid'};
  border-radius: ${theme.spacing.xsmall};
  border-color: ${({ hasErrors, isSelected }: StyledSelectableItemProps) => {
    if (hasErrors) return theme.color.error

    if (isSelected) return theme.color.borderPrimary

    return theme.color.borderSecondary
  }};

  ${({ noBorder }: StyledSelectableItemProps) =>
    noBorder &&
    css`
      border: none;
    `}

  cursor: pointer;

  background-color: ${({ isSelected }: StyledSelectableItemProps) => {
    if (isSelected) return theme.color.main

    return theme.color.white
  }};

  &:hover {
    background-color: ${({ isSelected }: StyledSelectableItemProps) => {
      if (isSelected) return theme.color.main

      return theme.color.mainHover
    }};
  }

  ${({ titleVariant }: StyledSelectableItemProps) => {
    if (!titleVariant) return ''

    return `
      border-radius: 0;
      padding-left: 1rem;
    `
  }}

  flex: 1;
`

function BuilderSelectableItem({
  id,
  dataCy,
  type,
  hasMakeSmallerOption,
  hasMakeBiggerOption,
  hasErrors,
  children,
  hideMenu,
  hasMoveUp,
  hasMoveDown,
  noBorder,
  dottedBorder,
  titleVariant,
  className,
  parentPageId,
}: Props): React.Node {
  const { getIsSelected, setSelectedItem, isReordering } =
    React.useContext(FormBuilderContext)

  const isSelected = getIsSelected(id, type)

  const onSelectClick = React.useCallback(() => {
    setSelectedItem({ id, type, parentPageId })
  }, [id, type, setSelectedItem, parentPageId])

  // I know. Styles. Hugh.
  // I'll remove them someday.
  // I was in a hurry.

  return (
    <div
      className={className}
      data-cy={dataCy}
      style={{
        position: 'relative',
        display: 'flex',
      }}
    >
      {isSelected && !isReordering && !hideMenu && (
        <div
          style={{
            position: 'absolute',
            zIndex: 999,
            top: -55,
          }}
        >
          <BuilderPopupQuestion
            hasMakeBiggerOption={hasMakeBiggerOption}
            hasMakeSmallerOption={hasMakeSmallerOption}
            hasMoveDown={hasMoveDown}
            hasMoveUp={hasMoveUp}
            id={id}
            onCloseRequest={() => undefined}
            type={type}
          />
        </div>
      )}
      <StyledSelectableItem
        dottedBorder={dottedBorder}
        hasErrors={hasErrors}
        isSelected={isSelected}
        noBorder={noBorder}
        onClick={onSelectClick}
        titleVariant={titleVariant}
      >
        {children}
      </StyledSelectableItem>
    </div>
  )
}

export default BuilderSelectableItem
